import _ from 'lodash';
import granitBaseData from '@json/contracting/granit/baseData';
import granitInsuredData from '@json/contracting/granit/insuredData';
import granitFinancingData from '@json/contracting/granit/financingData';
import colonnadeBaseData from '@json/contracting/colonnade/baseData';
import colonnadeInsuredData from '@json/contracting/colonnade/insuredData';
import colonnadeFinancingData from '@json/contracting/colonnade/financingData';
import kobeBaseData from '@json/contracting/kobe/baseData';
import kobeInsuredData from '@json/contracting/kobe/insuredData';
import kobeFinancingData from '@json/contracting/kobe/financingData';
import unionBaseData from '@json/contracting/union/baseData';
import unionInsuredData from '@json/contracting/union/insuredData';
import unionFinancingData from '@json/contracting/union/financingData';
import allianzBaseData from '@json/contracting/allianz/baseData';
import allianzInsuredData from '@json/contracting/allianz/insuredData';
import allianzFinancingData from '@json/contracting/allianz/financingData';
import generaliBaseData from '@json/contracting/generali/baseData';
import generaliInsuredData from '@json/contracting/generali/insuredData';
import generaliFinancingData from '@json/contracting/generali/financingData';
import alfaBaseData from '@json/contracting/alfa/baseData';
import alfaInsuredData from '@json/contracting/alfa/insuredData';
import alfaFinancingData from '@json/contracting/alfa/financingData';

class JsonHelper {
	constructor(insurer, type) {
		this.insurer = insurer.toLowerCase();
		this.type = type;
		this.data = {
			granit: {
				baseData: granitBaseData,
				insuredData: granitInsuredData,
				financingData: granitFinancingData,
			},
			colonnade: {
				baseData: colonnadeBaseData,
				insuredData: colonnadeInsuredData,
				financingData: colonnadeFinancingData,
			},
			kobe: {
				baseData: kobeBaseData,
				insuredData: kobeInsuredData,
				financingData: kobeFinancingData,
			},
			union: {
				baseData: unionBaseData,
				insuredData: unionInsuredData,
				financingData: unionFinancingData,
			},
			allianz: {
				baseData: allianzBaseData,
				insuredData: allianzInsuredData,
				financingData: allianzFinancingData,
			},
			generali: {
				baseData: generaliBaseData,
				insuredData: generaliInsuredData,
				financingData: generaliFinancingData,
			},
            alfa: {
                baseData: alfaBaseData,
                insuredData: alfaInsuredData,
                financingData: alfaFinancingData,
            },
		};
	}

	getDataForFormElements() {
		return _.mapValues(this.data[this.insurer][this.type], (group, gIndex) => {
			return _.mapValues(group, (field, fIndex) => {
				return {
					...field,
					input: {
						parent: this.type,
						group: gIndex,
						prop: fIndex,
					},
				};
			});
		});
	}
}

export default JsonHelper;
